import React, { useEffect, useState, useRef } from 'react';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { makeStyles } from '@mui/styles';
import { Grid, Avatar, Tooltip, Typography } from '@mui/material';

import Landing from './Landing';
import Details from './Details';
import Search from './Search';
import avatar_jeong from './avatar-jeong.jpg';
import avatar_nico from './avatar-nico.jpg';

const THEME = createTheme();
const GRADIENT = 'linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 0) 10%, rgba(222, 222, 222, 1) 85%, rgba(196, 196, 196, 1) 100%';

const useStyles = makeStyles(() => ({
    appbar: {
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        height: 80,
        zIndex: 2,
        paddingRight: 16,
        backgroundColor: 'rgba(255, 255, 255, .95)',
    },
    avatars: {
        position: 'fixed',
        top: 25,
        right: 25,
    },
    page: {
        position: 'relative',
        height: '100vh',
        width: '100vw',
    },
    footnote: {
        position: 'fixed',
        left: '50%',
        bottom: 24,
        transform: 'translateX(-50%)',
    },
}));

const App = () => {
    const classes = useStyles();

    const [pos, setPos] = useState(0);

    const ticking = useRef(false);
    useEffect(() => {
        const scrollSpy = document.addEventListener('scroll', () => {
            if (!ticking.current) {
                window.requestAnimationFrame(() => {
                    setPos(window.scrollY);
                    ticking.current = false;
                });
                ticking.current = true;
            }
        });
        return () => {
            document.removeEventListener('scroll', scrollSpy);
        };
    }, []);

    return (
        <ThemeProvider theme={THEME}>
            <Grid container direction="row-reverse" alignItems="center" wrap="nowrap" spacing={2} className={classes.appbar}>
                <Grid item><Tooltip arrow title="Nico Li"><Avatar alt="Nico" src={avatar_nico} /></Tooltip></Grid>
                <Grid item><Tooltip arrow title="Jeong Ook Moon"><Avatar alt="Jeong" src={avatar_jeong} /></Tooltip></Grid>
                <Grid item><Typography variant="button" color="primary">Squid Squad:</Typography></Grid>
            </Grid>
            <Grid container className={classes.page}>
                <Landing top={pos < 5} />
            </Grid>
            <Grid container className={classes.page}>
                <Details />
            </Grid>
            <Grid container className={classes.page} style={{ background: GRADIENT }}>
                <Search />
            </Grid>
        </ThemeProvider>
    );
}

export default App;
